"use strict";
var timepicker_component_1 = require('./timepicker/timepicker.component');
exports.TimepickerComponent = timepicker_component_1.TimepickerComponent;
var timepicker_module_1 = require('./timepicker/timepicker.module');
exports.TimepickerModule = timepicker_module_1.TimepickerModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/timepicker.js
// module id = 1211
// module chunks = 0